import { Drawer } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import { ButtonT1 } from "../../atoms/Button";
import { PortalFooterCard } from "../../atoms/Footer";
import { PortalHeader } from "../Header";
import { portalDrawerAntHeaderCss } from "../Header/Header.styles";

const DRAWER_WIDTH = "min(100vw, max(480px, 40vw))";

const panelStyles = {
  header: { padding: 0 },
  body: { padding: 0, overflow: "auto" },
  footer: { padding: 0 },
  mask: { backgroundColor: "rgba(0, 0, 0, 0.3)", backdropFilter: "blur(1px)" },
};

const DrawerHeaderTheme = createGlobalStyle`
  ${({ $rootClassName }) =>
    $rootClassName
      ? `
  .${$rootClassName} .ant-drawer-header {
    ${portalDrawerAntHeaderCss}
  }
`
      : ""}
`;

const Body = styled.div`
  padding: 16px 24px 24px;

  .intro {
    margin: 0 0 16px;
    color: var(--ASH, #676879);
    font-size: 14px;
    line-height: 1.5;
  }

  .fieldRow {
    margin-bottom: 16px;
  }
`;

const FooterBar = styled(PortalFooterCard)`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

/**
 * Right-side drawer chrome for in-form Create * masters.
 *
 * @param {object} props
 * @param {boolean} props.open Whether the drawer is visible.
 * @param {function(): void} props.onClose Cancel / overlay close.
 * @param {string} props.title Header title, for example "Create Customer".
 * @param {string=} props.intro Short hint above the fields.
 * @param {function(): void} props.onSubmit Primary button handler.
 * @param {string=} props.submitLabel Primary button label, default Create.
 * @param {boolean=} props.loading Disable and show a spinner on Create.
 * @param {boolean=} props.disabled Disable Create when the form is invalid.
 * @param {*} props.children Field markup.
 * @param {string=} props.rootClassName Ant drawer root class for header CSS.
 * @return {*}
 */
export const QuickCreateDrawer = ({
  open,
  onClose,
  title,
  intro,
  onSubmit,
  submitLabel = "Create",
  loading = false,
  disabled = false,
  children,
  rootClassName = "quick-create-drawer",
}) => (
  <>
    <DrawerHeaderTheme $rootClassName={rootClassName} key={rootClassName} />
    <Drawer
      open={open}
      onClose={onClose}
      title={<PortalHeader title={title} onClose={onClose} />}
      width={DRAWER_WIDTH}
      rootClassName={rootClassName}
      placement="right"
      closable={false}
      maskClosable
      destroyOnClose
      styles={panelStyles}
      footer={
        <FooterBar>
          <ButtonT1 type="button" title="Cancel" $variant="secondary" onClickCallback={onClose} />
          <ButtonT1
            type="button"
            title={submitLabel}
            $variant="primary"
            loading={loading}
            disabled={disabled || loading}
            onClickCallback={onSubmit}
          />
        </FooterBar>
      }
    >
      <Body>
        {intro ? <p className="intro">{intro}</p> : null}
        {children}
      </Body>
    </Drawer>
  </>
);
